import { html, LitElement } from 'lit';
import { translateFn } from 'apps/webcomponents/src/utils/translator.helper';
import { customElement, property, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../../ui/gzForm/formField';
import { FormGroup } from '../../../../../../../../ui/gzForm/formGroup/form-group';
import { styles } from '../view/styles';
import { connect } from 'pwa-helpers';
import { RootState, store } from '@nirvana/redux/store';
import { TextHighlightMixin } from '../../../../../../../../mixins';
import { selectAccordionsSearchState } from '@nirvana/redux/searchable-ui-accordions';
import { DetonationProfile } from '@nirvana/shared/dtos/types/policies/common';
import { GzSelectionCardGroupWebComponent } from '../../../../../../../../ui/gzSelectionCardGroup';

@customElement('gz-policy-panel-sandbox-detonation-profile')
export class GzDetonationProfileWebComponent extends TextHighlightMixin(connect(store)(LitElement)) {
  @property({ type: Object, attribute: true, reflect: true })
  public detonationProfileLabel: { label: string; translatedLabel: string } = {
    label: '',
    translatedLabel: '',
  };

  @query('#detonation-profile-form-field')
  public detonationProfileFormField: GzFormFieldWebComponent<GzSelectionCardGroupWebComponent>;

  public formGroup: FormGroup;

  /**
   * State changed, update search string.
   * @param rootState
   */
  public stateChanged(rootState: RootState) {
    const accordionsSearchApp = selectAccordionsSearchState(rootState);

    this.searchString = accordionsSearchApp.searchString;
  }

  /**
   * Template styles.
   */
  static get styles() {
    return styles;
  }

  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);

    this.buildFormGroup();
  }

  protected render() {
    return html`
      <gz-title
        searchable-label="${this.detonationProfileLabel.label}"
        fontSize="11"
        fontWeight="600"
        class="form-subtitle"
        >${this.detonationProfileLabel.translatedLabel}</gz-title
      >

      <gz-text fontSize="12" fontWeight="400" class="infoText"
        >${translateFn(
          'Allows you to choose between sandbox detonation time and detection accuracy, or to balance them.'
        )}
      </gz-text>

      <gz-form-field id="detonation-profile-form-field" class="mt-2">
        <gz-selection-card-group gz-form-input>
          <gz-selection-card
            label="${translateFn('High')}"
            .value="${DetonationProfile.HIGH}"
            .id="${'detonation-profile-high'}"
          >
            <div slot="content">
              <gz-title fontSize="12" fontWeight="600" style="margin-bottom: 8px"
                >${translateFn('Advanced analysis')}
              </gz-title>
              <gz-text fontSize="12" style="margin-bottom: 8px"
                >${translateFn(
                  'Get the best analysis accuracy. The side effect is a less than optimal detonation throughput.'
                )}
              </gz-text>
            </div>
          </gz-selection-card>
          <gz-selection-card
            label="${translateFn('Medium')}"
            .value="${DetonationProfile.MEDIUM}"
            .id="${'detonation-profile-medium'}"
          >
            <div slot="content">
              <gz-title fontSize="12" fontWeight="600" style="margin-bottom: 8px"
                >${translateFn('Optimal analysis')}
              </gz-title>
              <gz-text fontSize="12" style="margin-bottom: 8px"
                >${translateFn('The optimal balance between detonation time and analysis accuracy.')}
              </gz-text>
            </div>
          </gz-selection-card>
          <gz-selection-card
            label="${translateFn('Low')}"
            .value="${DetonationProfile.LOW}"
            .id="${'detonation-profile-low'}"
          >
            <div slot="content">
              <gz-title fontSize="12" fontWeight="600" style="margin-bottom: 8px"
                >${translateFn('Basic analysis')}
              </gz-title>
              <gz-text fontSize="12" style="margin-bottom: 8px"
                >${translateFn(
                  'Increase the Sandbox Analyzer throughput by reducing the complexity of detonation analysis. The accuracy of the detection remains in acceptable standards.'
                )}
              </gz-text>
            </div>
          </gz-selection-card>
        </gz-selection-card-group>
      </gz-form-field>
    `;
  }

  private buildFormGroup() {
    this.formGroup = FormGroup.build({
      value: this.detonationProfileFormField,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-policy-panel-sandbox-detonation-profile': GzDetonationProfileWebComponent;
  }
}
